/* VF Shop by platform — snippets/vf_platform-picker.liquid (homepage + /pages/enthusiast-platforms)
   Three-step wizard: make logos -> that make's platform cards -> a year strip
   for the chosen platform. Each year links to the collections index with that
   exact vehicle applied (category picker). Build guides are not part of this
   flow; they stay standalone SEO landing pages.

   Every step is a browser history entry (Asif, 2026-09-17 23:56): a make
   click pushes ?platform=<make>, a card click pushes ?platform=<make>&car=<card>,
   the Back/Esc controls call history.back(), and loading a URL with those
   params opens that step directly. So the browser Back button always returns
   to the list you came from, including from a collections page. Query params,
   not a hash: Convermax's search router grabs any location.hash on load and
   rewrites the URL to /pages/search. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var PARAM_MAKE = 'platform';
  var PARAM_CARD = 'car';

  function init(root) {
    if (root.dataset.vfPpReady) return;
    root.dataset.vfPpReady = '1';

    var makesSlide = root.querySelector('[data-vf-pp-slide="makes"]');
    var platformsSlide = root.querySelector('[data-vf-pp-slide="platforms"]');
    var yearsSlide = root.querySelector('[data-vf-pp-slide="years"]');
    if (!makesSlide || !platformsSlide || !yearsSlide) return;

    var STEPS = { makes: 0, platforms: 1, years: 2 };
    var current = { step: 'makes', make: null, card: null };
    // Number of history entries this picker has pushed that are still behind
    // us. history.state is not trusted for this: other scripts on the page
    // (Convermax) replace the entry's state on URL changes.
    var pushed = 0;

    // Collections index with the vehicle applied: Convermax shows the category
    // tiles for that exact car there, so the shopper picks a category next
    // instead of landing in the full parts list (Asif, 2026-09-17 22:55).
    function catalogUrl(year, make, model) {
      return '/collections?' + ['Year', year, 'Make', make, 'Model', model].map(encodeURIComponent).join('/');
    }

    /* ---- URL <-> state ------------------------------------------------ */

    function cssEscape(s) {
      return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
    }

    // ?platform=bmw or ?platform=bmw&car=bmw-m3-g80 -> state, or null when the
    // params are absent / name something the section doesn't have.
    function stateFromUrl(search) {
      var params = new URLSearchParams(search);
      var make = params.get(PARAM_MAKE), card = params.get(PARAM_CARD);
      if (!make || !platformsSlide.querySelector('[data-vf-pp-panel="' + cssEscape(make) + '"]')) return null;
      if (card) {
        var el = platformsSlide.querySelector('[data-vf-pp-card="' + cssEscape(card) + '"]');
        if (!el || el.closest('[data-vf-pp-panel]').getAttribute('data-vf-pp-panel') !== make) return null;
        return { step: 'years', make: make, card: card };
      }
      return { step: 'platforms', make: make, card: null };
    }

    // Same page, same other params and hash, only our two params changed
    function urlFor(state) {
      var params = new URLSearchParams(location.search);
      params.delete(PARAM_MAKE);
      params.delete(PARAM_CARD);
      if (state.step !== 'makes') params.set(PARAM_MAKE, state.make);
      if (state.step === 'years') params.set(PARAM_CARD, state.card);
      var q = params.toString();
      return location.pathname + (q ? '?' + q : '') + location.hash;
    }

    function pushState(state) {
      history.pushState({ vfPp: state }, '', urlFor(state));
    }

    function replaceState(state) {
      history.replaceState({ vfPp: state }, '', urlFor(state));
    }

    function same(a, b) {
      return a.step === b.step && a.make === b.make && a.card === b.card;
    }

    /* ---- rendering ---------------------------------------------------- */

    function slideFor(step) {
      return step === 'makes' ? makesSlide : step === 'platforms' ? platformsSlide : yearsSlide;
    }

    function swap(hide, show, backwards, animate) {
      if (hide !== show) hide.hidden = true;
      hide.classList.remove('vf-pp__slide--enter', 'vf-pp__slide--enter-back');
      show.hidden = false;
      show.classList.remove('vf-pp__slide--enter', 'vf-pp__slide--enter-back');
      if (animate && !reduceMotion.matches) {
        show.classList.add(backwards ? 'vf-pp__slide--enter-back' : 'vf-pp__slide--enter');
      }
    }

    function fillYears(card) {
      var d = card.dataset;
      yearsSlide.querySelector('[data-vf-pp-years-make]').textContent = d.make;
      yearsSlide.querySelector('[data-vf-pp-years-label]').textContent = d.label;
      yearsSlide.querySelector('[data-vf-pp-years-span]').textContent = d.make + ' \u00b7 ' + d.span;
      var line = yearsSlide.querySelector('[data-vf-pp-years-line]');
      var photo = yearsSlide.querySelector('[data-vf-pp-years-photo]');
      line.src = d.line;
      if (d.photo) { photo.src = d.photo; photo.hidden = false; } else { photo.removeAttribute('src'); photo.hidden = true; }
      yearsSlide.querySelector('.vf-pp__years-art').classList.toggle('vf-pp__years-art--photo', !!d.photo);
      var list = yearsSlide.querySelector('[data-vf-pp-years-list]');
      list.textContent = '';
      d.years.split(',').forEach(function (year) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'vf-pp__year';
        a.href = catalogUrl(year, d.make, d.model);
        a.textContent = year;
        a.setAttribute('aria-label', year + ' ' + d.make + ' ' + d.model + ' parts');
        li.appendChild(a);
        list.appendChild(li);
      });
    }

    // Show a step. opts: animate (slide transition), focus (move focus to the
    // step's heading, or to the control you came from when going up), scroll
    // (bring the section into view even when it is below the fold).
    function render(state, opts) {
      opts = opts || {};
      var from = current;
      var backwards = STEPS[state.step] < STEPS[from.step];
      var panel = state.make ? platformsSlide.querySelector('[data-vf-pp-panel="' + cssEscape(state.make) + '"]') : null;
      var card = state.card ? platformsSlide.querySelector('[data-vf-pp-card="' + cssEscape(state.card) + '"]') : null;

      if (state.step !== 'makes') {
        platformsSlide.querySelectorAll('[data-vf-pp-panel]').forEach(function (p) { p.hidden = p !== panel; });
      }
      if (state.step === 'years' && card) fillYears(card);

      swap(slideFor(from.step), slideFor(state.step), backwards, opts.animate !== false);
      root.setAttribute('data-vf-pp-state', state.step);
      current = state;

      if (opts.scroll || root.getBoundingClientRect().top < 0) {
        root.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      }
      if (opts.focus !== false) {
        var target = null;
        if (backwards) {
          target = state.step === 'makes'
            ? makesSlide.querySelector('[data-vf-pp-make="' + cssEscape(from.make || '') + '"]')
            : panel && panel.querySelector('[data-vf-pp-card="' + cssEscape(from.card || '') + '"]');
        } else if (state.step === 'platforms') {
          target = panel && panel.querySelector('.vf-pp__panel-title');
        } else if (state.step === 'years') {
          target = yearsSlide.querySelector('.vf-pp__years-title');
        }
        if (target) target.focus({ preventScroll: true });
      }
    }

    /* ---- navigation: forward pushes history, back pops it -------------- */

    function goTo(state) {
      render(state, { animate: true });
      pushState(state);
      pushed += 1;
    }

    // Back/Esc: when this step is our own history entry, let the browser pop
    // it so the stack stays honest. Otherwise (deep link, or history.state
    // lost) render the parent step in place.
    function goUp() {
      var parent = current.step === 'years'
        ? { step: 'platforms', make: current.make, card: null }
        : { step: 'makes', make: null, card: null };
      if (pushed > 0) {
        history.back();
      } else {
        // Deep link / no entry of ours behind us: render in place
        render(parent, { animate: true });
        replaceState(parent);
      }
    }

    window.addEventListener('popstate', function (event) {
      var state = (event.state && event.state.vfPp) || stateFromUrl(location.search) || { step: 'makes', make: null, card: null };
      if (same(state, current)) return;
      if (STEPS[state.step] < STEPS[current.step]) pushed = Math.max(0, pushed - 1);
      else pushed += 1;
      render(state, { animate: true });
    });

    root.addEventListener('click', function (event) {
      var make = event.target.closest('[data-vf-pp-make]');
      if (make) { goTo({ step: 'platforms', make: make.getAttribute('data-vf-pp-make'), card: null }); return; }
      var card = event.target.closest('[data-vf-pp-card]');
      if (card) { goTo({ step: 'years', make: current.make, card: card.getAttribute('data-vf-pp-card') }); return; }
      if (event.target.closest('[data-vf-pp-back-platforms]') || event.target.closest('[data-vf-pp-back]')) { goUp(); return; }
      var fallback = event.target.closest('[data-vf-pp-fallback]');
      if (fallback) {
        // The Convermax YMM band is the section right after this one; find it
        // by the section handle so the template id can change (theme copies).
        // Pages without the band (e.g. /pages/enthusiast-platforms) pass their own
        // anchor as the link's href; scroll to that when it exists.
        var href = fallback.getAttribute('href') || '';
        var band = (href.charAt(0) === '#' && href.length > 1 && document.getElementById(href.slice(1))) ||
          document.querySelector('[id$="__1763575261316a5273"]') ||
          root.closest('.shopify-section') && root.closest('.shopify-section').nextElementSibling;
        if (band) {
          event.preventDefault();
          band.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        }
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || current.step === 'makes') return;
      event.preventDefault();
      goUp();
    });

    // Touch devices have no hover: a card fills in with the photo only while
    // most of it sits in the middle quarter of the viewport, and reverts to
    // the outline as soon as it leaves. The band is narrower than two card
    // rows so at most one row is ever filled in. No touchstart hook: a scroll
    // drag fires touchstart on every card under the finger and would light
    // them all up. Desktop keeps the pure hover crossfade.
    if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-revealed', e.isIntersecting); });
      }, { rootMargin: '-38% 0px -38% 0px', threshold: 0.6 });
      root.querySelectorAll('.vf-pp__card--photo').forEach(function (card) { io.observe(card); });
    }

    // A card whose color art fails to load stays an outline card
    root.querySelectorAll('.vf-pp__photo').forEach(function (img) {
      img.addEventListener('error', function () {
        var card = img.closest('.vf-pp__card');
        if (card) card.classList.remove('vf-pp__card--photo');
        img.remove();
      });
    });

    // Initial step. A history entry we wrote earlier (bfcache miss after
    // Back from a collections page) or a deep link (?platform=<make>[&car=<card>])
    // opens that step with no transition; a deep link also scrolls the section
    // into view and is marked so Back/Esc render the parent instead of leaving
    // the page. Every entry gets a state object so popstate can tell ours apart.
    root.setAttribute('data-vf-pp-state', 'makes');
    var fromEntry = history.state && history.state.vfPp;
    var fromHash = stateFromUrl(location.search);
    if (fromEntry) {
      render(fromEntry, { animate: false, focus: false });
    } else if (fromHash) {
      render(fromHash, { animate: false, focus: false, scroll: true });
    }
    replaceState(current);
  }

  function boot() {
    document.querySelectorAll('[data-vf-pp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', boot);
})();
